<template>
	<section class="main-content h1-content">
		<div class="row align-center">
			<picture class="intro-graphic">
				<source :srcset="graphic.imageWebp" type="image/webp" />
				<source :srcset="graphic.image" />
				<img :src="graphic" :alt="graphic.alt" />
			</picture>
			<div class="columns column12">
				<h1>{{ title }}</h1>
				<div class="bottom-content">
					<div v-if="content" v-parse-links class="bottom-content-text" v-html="content" />
					<nuxt-link v-if="button.text" class="button" :to="button.link">
						<strong>{{ button.text }}</strong>
					</nuxt-link>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: Object, default: () => ({ text: '', link: '' }) },
	graphic: {
		type: Object,
		default: () => ({
			image: '',
			imageWebp: '',
			alt: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.h1-content {
	padding: 140px 0;
	margin: 0 auto;
	background: var(--alternating-background-color);
	color: var(--subtitle-color);
	text-align: center;

	.intro-graphic {
		margin: 0 auto 50px;
		width: 90px;
	}

	.row {
		max-width: 800px;
	}

	h1 {
		color: var(--subtitle-color);
	}

	.bottom-content {
		margin: 80px 0 0;

		.bottom-content-text {
			margin-bottom: 80px;
		}

		p,
		:deep(p) {
			margin-bottom: 0;
		}
	}

	.button,
	:deep(.button),
	.button-no-fill,
	:deep(.button-no-fill) {
		color: var(--subtitle-color);
		border-color: var(--subtitle-color);
		padding: 16px 35px;
		text-transform: uppercase;
		font-weight: 500;
		letter-spacing: 1px;

		&:hover {
			background: var(--subtitle-color);
			border-color: var(--subtitle-color);
			color: #fff;
		}
	}

	:deep(.button::after),
	.button::after {
		display: none;
	}
}
</style>
